// extracted by mini-css-extract-plugin
export default {"list":"TwoFactorAuthList_list__FFZGi"};